import React, {use, useState} from "react";
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [ formData, setFormData ] = useState({username:'', password:''});
    const [ error, setError] = useState('');
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await fetch('/admin/login', {
            method: 'POST',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({ username: formData.username, password: formData.password })
        });
        
        const data = await res.json();
        if (res.ok) {
            navigate('/store/admin');
        } else {
            setError(data.error);
        }
    }

    return (
        <main> 
            <form class="login-form" onSubmit={handleSubmit}>
                <h2>Login</h2>
                
                <div class="form-group">
                    <label for="username">Username</label>
                    <input 
                        onChange={handleChange} 
                        value={formData.username} 
                        name="username"
                        type="username" 
                        id="username" 
                        placeholder="Benutzername" 
                        required 
                    />
                </div>

                <div class="form-group">
                    <label for="password">Password</label>
                    <input 
                        onChange={handleChange} 
                        value={formData.password} 
                        name="password"
                        type="password" 
                        id="password" 
                        placeholder="Passwort" 
                        required 
                    />
                </div>

                <button type="submit" class="login-btn">Log In</button>
                {error && <p>{error}</p>}

            </form>
        </main>
    )
}

export default Login;
